import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { fullName, fmtDateTime, relDate, isOverdue, isInvalidPhone } from "@/lib/crm";
import { TemperatureBadge } from "@/components/crm/Badges";
import { Button } from "@/components/ui/button";
import { Phone, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

// Appuntamenti programmati (DA FARE) mostrati nella sezione Attività
export default function ActivityAppointments({ appts, isAdmin, onEdit, onChanged }) {
  const navigate = useNavigate();
  const remove = async (a) => {
    if (!window.confirm("Sei sicuro di voler eliminare questo appuntamento? Il lead e le altre informazioni non verranno toccati.")) return;
    try {
      await api.delete(`/appointments/${a.id}`);
      toast.success("Appuntamento eliminato");
      onChanged();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };

  if (appts.length === 0) return <div className="p-12 text-center text-muted-foreground text-sm">Nessun appuntamento programmato.</div>;
  return (
    <ul className="divide-y" data-testid="activity-appointments-list">
      {appts.map((a) => (
        <li key={a.id} data-testid={`activity-appt-${a.id}`} className="flex flex-wrap sm:flex-nowrap items-center gap-x-3 gap-y-2 px-4 py-3 hover:bg-muted/40 transition-colors">
          {a.lead && <TemperatureBadge value={a.lead.temperature} />}
          <div className="flex-1 min-w-[12rem]">
            <div className="font-medium truncate">
              {a.lead ? fullName(a.lead) : "Lead non disponibile"}
              <span className="ml-2 text-[11px] px-1.5 py-0.5 rounded bg-secondary font-normal" data-testid={`activity-appt-tipologia-${a.id}`}>{a.tipologia || "Non specificata"}</span>
            </div>
            <div className={cn("text-xs", isOverdue(a.start_at) ? "text-amber-600 dark:text-amber-400" : "text-muted-foreground")}>
              {fmtDateTime(a.start_at)} ({relDate(a.start_at)}) · {a.mode} · {a.duration} min{isAdmin && a.user?.name ? ` · ${a.user.name}` : ""}
            </div>
            {a.note && <div className="text-xs text-muted-foreground truncate mt-0.5">{a.note}</div>}
          </div>
          <div className="flex items-center gap-2 ml-auto">
          {a.lead?.phone && !isInvalidPhone(a.lead.phone) && <a href={`tel:${a.lead.phone}`} className="inline-flex items-center justify-center w-8 h-8 rounded-md bg-emerald-500 text-white hover:bg-emerald-600"><Phone className="w-4 h-4" /></a>}
          {a.lead && <Button size="sm" variant="secondary" data-testid={`activity-appt-open-${a.id}`} onClick={() => navigate(`/leads/${a.lead.id}`)}>Apri</Button>}
          <Button size="sm" variant="outline" data-testid={`activity-appt-edit-${a.id}`} onClick={() => onEdit(a)} title="Modifica appuntamento"><Pencil className="w-3.5 h-3.5" /></Button>
          <Button size="sm" variant="outline" data-testid={`activity-appt-delete-${a.id}`} onClick={() => remove(a)} className="text-red-600 hover:bg-red-500/10 border-red-500/30" title="Elimina appuntamento"><Trash2 className="w-3.5 h-3.5" /></Button>
          </div>
        </li>
      ))}
    </ul>
  );
}
